<template>
  <RevCard
    class="h-full"
    :class="
      isProductCompared ? 'border-action-default-hi' : 'border-transparent'
    "
    data-qa="productCard"
    :hoverable="true"
  >
    <ProductCardContent
      :comparison="{
        isComparisonEnabled,
        isComparisonAddProductDisabled,
        isResponsiveComparisonEnabled,
        comparisonProducts,
      }"
      :options="{
        withAddToCart: addToCartListener,
        position,
        withStartingFrom,
        extendedDescription,
        tracking,
      }"
      :product="{
        ...product,
        listingId: listingId,
        rawProduct: product.product,
      }"
      @add-to-cart="
        ({ status }) => {
          emit('add-to-cart', { status })
        }
      "
      @link-click="emit('link-click', $event)"
      @toggle-comparison-product="emit('toggle-comparison-product', listingId)"
    />
  </RevCard>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue'

import { RevCard } from '@ds/components/Card'

import type { ExtraTrackingData } from '../../composables/useProductTracking'
import type { Product } from '../../models/product'

import type { ProductCardProduct } from './ProductCard.types'
import ProductCardContent from './ProductCardContent.vue'

export interface ProductCardProps extends Omit<
  ProductCardProduct,
  'rawProduct'
> {
  product: Product
  position?: number
  withStartingFrom?: boolean
  extendedDescription?: boolean
  tracking?: ExtraTrackingData
}

const {
  listingId,
  comparisonProducts,
  isComparisonAddProductDisabled = false,
  isResponsiveComparisonEnabled = false,
  extendedDescription = false,
  ...product
} = defineProps<ProductCardProps>()

const emit = defineEmits([
  'add-to-cart',
  'toggle-comparison-product',
  'link-click',
])

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

const isProductCompared = computed(() => {
  return comparisonProducts?.some((p) => p.listingId === listingId) || false
})
</script>
